import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const { loginWithRedirect } = useAuth0();

  const handleCheckboxChange = () => {
    setRememberMe((prev) => !prev);
  };

  return (
    <div className="flex-center full-screen bg-gray">
      <div className="signup-container">
        <img src="/assets/images/x.svg" alt="close tab" className="close-btn" />
        <h1 className="center-mobile">Sign In to Helpful</h1>
        <p className="signin-link center-mobile">
          New to Helpful? <a href="/sign-up">Sign up now</a>
        </p>
        <form onSubmit={loginWithRedirect}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="action-form-btn sign-in-btn">
            Sign In
          </button>
          <div className="split-content text-sm text-gray">
            <label className="remember-me-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={handleCheckboxChange}
                className="remember-me-checkbox"
              />
              Remember&nbsp;me
            </label>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="need-help-link">Need help?</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
